import { Component, OnInit } from '@angular/core';
import { ApiservicesService } from '../../../apiservices.service';
import { EncryptdecryptService } from '../../../services/encryptdecrypt.service';

@Component({
  selector: 'app-e-ckht',
  templateUrl: './e-ckht.component.html',
  styleUrls: ['./e-ckht.component.css']
})
export class ECkhtComponent implements OnInit {
  //UI Status Variables
  LoaderStatus: boolean = false;
  SearchStatus: boolean = false;

  //UI View Alert Variables
  AlertType: string = "";
  AlertStatus: boolean = false;
  AlertMessage: string = "";

  //UI Input Variables
  TINInput: any = "";
  AgentInput: any = "";

  //UI View Variables
  TINView: any = "";
  ItGrpCdView: any = "";
  TaxpNameView: any = "";

  //Session Variables
  SessionFirmID: any = "";
  SessionStaffID: any = "";
  SessionLanguage: any = "";

  //Array Variables
  AgentList: any = new Array;

  //Datatable
  displayedColumns = ['jenisborang', 'tahun', 'action'];

  constructor(private apiServices: ApiservicesService, private encryptDecryptService: EncryptdecryptService) { }

  ngOnInit(): void {
    this.SessionFirmID = this.encryptDecryptService.decrypt(sessionStorage.getItem('FirmID') || '');
    this.SessionStaffID = this.encryptDecryptService.decrypt(sessionStorage.getItem('StaffID') || '');
    this.SessionLanguage = sessionStorage.getItem('Language');
  }
  async Submit(TIN: any) {
    this.LoaderStatus = true;
    if (TIN === "") {
      this.AlertType = "fail";
      this.AlertMessage = "Sila masukkan butiran";
      this.AlertStatus = true;
      setTimeout(() => {
        this.AlertStatus = false;
      }, 1001);
      this.LoaderStatus = false;
      this.SearchStatus = false;
    } else {
      let Params = {
        "firmID": Number(this.SessionFirmID),
        "itRefNo": Number(TIN),
        "formType":"CKHT"
      };
      const result = await this.apiServices.SharedIntegrationDetail(Params);
      if (result.hasError) {
        this.AlertType = "fail";
        this.AlertMessage = result.errMsg;
        this.AlertStatus = true;
        setTimeout(() => {
          this.AlertStatus = false;
        }, 1001);
        this.LoaderStatus = false;
        this.SearchStatus = false;
      } else {
        this.GetAgent(this.SessionFirmID);
        this.TINView = result.taxPayer.iT_Ref_No;
        this.ItGrpCdView = result.taxPayer.jenisFail;
        this.TaxpNameView = result.taxPayer.nama;
        this.SearchStatus = true;
        this.LoaderStatus = false;
      }
    }
  }
  async Login(TIN: any, AgentID: any) {
    if (AgentID === "") {
      this.AlertType = "fail";
      this.AlertMessage = "Sila pilih ejen cukai";
      this.AlertStatus = true;
      setTimeout(() => {
        this.AlertStatus = false;
      }, 1001);
      this.LoaderStatus = false;
    } else {
      let Params = {
        "firmID": Number(this.SessionFirmID),
        "itRefNo": Number(TIN),
        "staffID": Number(this.SessionStaffID),
        "taxAgentID": Number(AgentID),
        "formType": "CKHT",
        "signature": sessionStorage.getItem('token'),
        "language": this.SessionLanguage 
      };
      const result = await this.apiServices.SharedIntegrationLogin(Params);
      if (result.hasError) {
        this.AlertType = "fail";
        this.AlertMessage = result.errMsg;
        this.AlertStatus = true;
        setTimeout(() => {
          this.AlertStatus = false;
        }, 1001);
        this.LoaderStatus = false;
        this.SearchStatus = false;
      } else {
        window.open(result.url, "_blank");
      }
    }
  }
  async GetAgent(FirmID: any) {
    let Params = {
      "FirmID": FirmID,
      "Role": "0204",
      "NonExpiredTaxAgent": false
    }
    const result = await this.apiServices.GetFirmStaff(Params);
    this.AgentList = result;
  }
  Semula() {
    this.LoaderStatus = false;
    this.SearchStatus = false;
    this.AlertStatus = false;
    this.TINInput = "";
  }

}
